CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
Notification = require 'models/notification'
_ = require 'underscore'

module.exports = class NotificationGroup extends CollectionWithHelpers
  model: Notification
  groupings: {}

  constructor: (models, options) ->
    super(models, _.extend({ silent: false }, options))
    return

  initialize: ->
    @listenTo(@, 'add remove reset update change', @_regroup)

  comparator: (notification) ->
    -(new Date(notification.get('date'))).getTime()

  _orderGroup: (notifications, order = 'desc') ->
    sort = { 'asc': 1, 'desc': -1 }

    _.sortBy notifications, (notification) ->
      sort[order] * (new Date(notification.get('date'))).getTime()

  _regroup: ->
    @groupings = {}

    @forEach (notification) =>
      try
        # Sometimes an error is thrown when trying to regroup, because the
        # notification is not yet available in the modelCache. The regrouping
        # works properly despite the error.
        data = notification.getExpandedData()
        groupId = notification.id
        isCard = false

        if data.card?
          groupId = data.card.id
          isCard = true

        @groupings[groupId] ?= {
          notifications: []
          isCard
          unread: false
          unreadCount: 0
          card: data.card if isCard
          board: data.board if isCard
          list: data.list if isCard
        }

        @groupings[groupId].notifications.push(notification)

        if data.unread
          if !@groupings[groupId].unread
            @groupings[groupId].unread = true
          @groupings[groupId].unreadCount++
      catch err
        return

    @groupings = _.mapObject(@groupings, (group) =>
      group.notifications = @_orderGroup(group.notifications, 'asc')
      group
    )

  totalUnreadNotifications: ->
    @filter (notification) -> notification.get('unread')
      .length



// WEBPACK FOOTER //
// ./app/scripts/models/collections/notification-group.coffee